"use client";

import { ItemType } from "@knowt/syncing/graphql/schema";
import Footer from "@/components/Footer";
import LogPageView from "@/components/LogPageVisit";
import PasswordProtectedAndPrivateFileContent from "./PasswordProtectedAndPrivateFileContent";
import { MainContainer, InnerContainer } from "@/components/Containers";

const PasswordProtectedAndPrivateFileComponent = ({
    type,
    itemId,
    fullyPrivate,
}: {
    type: ItemType;
    itemId: string;
    fullyPrivate?: boolean;
}) => {
    return (
        <>
            <LogPageView page={`Password Protected ${type} - Opened`} />
            <MainContainer style={{ marginBlock: "6rem 8rem", marginInline: "2rem 2rem" }} footerAds={true}>
                <InnerContainer>
                    <PasswordProtectedAndPrivateFileContent type={type} itemId={itemId} fullyPrivate={fullyPrivate} />
                </InnerContainer>
            </MainContainer>
            <Footer ad={true} data-testid="auto-id-87746ccb-dd20-4158-baa0-90d40e109b55" />
        </>
    );
};

export default PasswordProtectedAndPrivateFileComponent;
